export const adminInput =
  "w-full bg-cream border border-input px-3 py-2.5 text-sm text-wood focus:border-sage focus:outline-none transition-colors duration-300";

export const adminLabel = "block text-[0.62rem] uppercase tracking-[0.16em] text-wood/55 mb-1.5";

export function AdminField({ label, children, className = "" }) {
  return (
    <label className={`block ${className}`}>
      <span className={adminLabel}>{label}</span>
      {children}
    </label>
  );
}

export function AdminCard({ title, action, children, className = "", testId }) {
  return (
    <section className={`border border-border bg-cream ${className}`} data-testid={testId}>
      {(title || action) && (
        <header className="flex items-center justify-between gap-4 border-b border-border px-5 py-4">
          <h2 className="font-serif text-xl text-wood">{title}</h2>
          {action}
        </header>
      )}
      <div className="p-5">{children}</div>
    </section>
  );
}

export function AdminButton({ children, variant = "solid", className = "", ...rest }) {
  const styles = {
    solid: "bg-sage text-cream hover:bg-sage-deep",
    wood: "bg-wood text-cream hover:bg-wood-deep",
    outline: "border border-wood/30 text-wood hover:bg-wood hover:text-cream",
    danger: "border border-destructive/50 text-destructive hover:bg-destructive hover:text-cream",
    ghost: "text-wood/70 hover:text-sage",
  };
  return (
    <button
      type="button"
      className={`inline-flex items-center justify-center gap-1.5 px-4 py-2.5 text-[0.65rem] uppercase tracking-[0.16em] transition-colors duration-400 disabled:opacity-50 ${styles[variant]} ${className}`}
      {...rest}
    >
      {children}
    </button>
  );
}

export function EmptyState({ title, description, testId }) {
  return (
    <div className="border border-dashed border-wood/25 px-6 py-12 text-center" data-testid={testId}>
      <p className="font-serif text-xl text-wood">{title}</p>
      {description && <p className="mt-2 text-sm text-foreground/60">{description}</p>}
    </div>
  );
}
